// Compact request-workspace grid table shell shared by request surfaces.
// The shell owns: CSS-grid layout, sticky uppercase 10-px letter-spaced
// header cells, and the surrounding scroll container. Row content + cell
// layout stay feature-local so each surface keeps its own data shape.
// See `apps/web/docs/request-workspace-ui-contract.md`.

import type { CSSProperties, ReactNode } from 'react';

export interface WorkspaceTableColumn {
  key: string;
  label: ReactNode;
  align?: 'left' | 'right';
}

export interface WorkspaceTableProps {
  /** CSS grid `gridTemplateColumns` value. */
  columnsTemplate: string;
  columns: readonly WorkspaceTableColumn[];
  /** Row cells laid out across the same grid as the header. */
  children: ReactNode;
}

const HEADER_CELL_BASE: CSSProperties = {
  padding: '0 10px',
  height: 30,
  display: 'flex',
  alignItems: 'center',
  fontSize: 10,
  letterSpacing: '.08em',
  textTransform: 'uppercase',
  fontWeight: 600,
  color: 'var(--fg-3)',
  borderBottom: '1px solid var(--border-1)',
  background: 'var(--bg-1)',
  position: 'sticky',
  top: 0,
  zIndex: 1,
};

export function WorkspaceTable({ columnsTemplate, columns, children }: WorkspaceTableProps) {
  return (
    <div style={{ display: 'grid', gridTemplateColumns: columnsTemplate }}>
      {columns.map((c) => (
        <div
          key={c.key}
          style={{
            ...HEADER_CELL_BASE,
            justifyContent: c.align === 'right' ? 'flex-end' : 'flex-start',
          }}
        >
          {c.label}
        </div>
      ))}
      {children}
    </div>
  );
}
